import { render, staticRenderFns } from "./payment_result.vue?vue&type=template&id=e82e0ba0&scoped=true&"
import script from "./payment_result.vue?vue&type=script&lang=js&"
export * from "./payment_result.vue?vue&type=script&lang=js&"
import style0 from "./payment_result.vue?vue&type=style&index=0&id=e82e0ba0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82e0ba0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
